import { Component, ChangeDetectionStrategy, forwardRef, inject, OnInit, input, model, viewChild } from '@angular/core';
import { ScrollPickerDirective } from '@cue/utilities';
import {
  DateTimePickerComponent,
  DateTimePickerModule,
  PopupSettings,
  TimePickerIncrementalSteps,
  TimePickerModule,
} from '@progress/kendo-angular-dateinputs';
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { translation } from '@cue/translations';

import { TranslocoPipe } from '@jsverse/transloco';
import { FloatingLabelComponent } from '@progress/kendo-angular-label';

@Component({
  selector: 'assist-datetimepicker',
  templateUrl: './datetimepicker.component.html',
  styleUrls: ['./datetimepicker.component.scss'],
  imports: [
    DateTimePickerModule,
    DateTimePickerModule,
    TranslocoPipe,
    ReactiveFormsModule,
    ScrollPickerDirective,
    TimePickerModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatetimepickerComponent),
      multi: true,
    },
  ],
})
export class DatetimepickerComponent implements ControlValueAccessor, OnInit {
  public floatingLabel = inject(FloatingLabelComponent, { optional: true });
  private controlContainer = inject(ControlContainer, { optional: true, host: true, skipSelf: true });
  picker = viewChild(DateTimePickerComponent);

  steps = input<TimePickerIncrementalSteps>();
  format = input('HH:mm');
  min = input<Date>();
  max = input<Date>();
  popupSettings = model<PopupSettings>();

  translation = translation;
  private _ignoreEmit = false;

  _control = new FormControl<Date>(null);
  onChange: any = (val) => {
    // keep
  };
  onTouch: any = (val) => {
    // keep
  };

  get kendoPicker(): DateTimePickerComponent {
    return this.picker();
  }

  ngOnInit() {
    this._control.valueChanges.subscribe((val) => {
      if (this._ignoreEmit) {
        this._ignoreEmit = false;
      } else {
        this.onChange(val);
      }
    });
  }

  focus() {
    this.onTouch();
    if (this.floatingLabel) {
      this.floatingLabel.focused = true;
    }
  }

  blur() {
    if (this.floatingLabel) {
      this.floatingLabel.focused = false;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(obj: any): void {
    this._ignoreEmit = true;
    this._control.setValue(obj);
  }
}
